import { render, staticRenderFns } from "./HelpBaseBlock.vue?vue&type=template&id=24562710&scoped=true"
import script from "./HelpBaseBlock.vue?vue&type=script&lang=js"
export * from "./HelpBaseBlock.vue?vue&type=script&lang=js"
import style0 from "./HelpBaseBlock.vue?vue&type=style&index=0&id=24562710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24562710",
  null
  
)

export default component.exports